// Lib Imports
import { Children, useMemo, useEffect, useState } from 'react';
export const DeferMount = ({
  chunkSize,
  children,
  timeout = 200
}) => {
  const [renderedItemsCount, setRenderedItemsCount] = useState(chunkSize);
  const childrenArray = useMemo(() => Children.toArray(children), [children]);
  useEffect(() => {
    if (renderedItemsCount < childrenArray.length) {
      window.requestIdleCallback(() => {
        setRenderedItemsCount(Math.min(renderedItemsCount + chunkSize, childrenArray.length));
      }, {
        timeout
      });
    }
  }, [renderedItemsCount, childrenArray.length, chunkSize, timeout]);
  return childrenArray.slice(0, renderedItemsCount);
};